export enum TextWeight {
  REGULAR = 'regular-weight',
  MULTI = 'multi-weight',
  BOLD = 'bold',
}
export enum IconAlignment {
  DEFAULT = 'default',
  CENTER = 'icon-center-alignment',
}
export enum AlertMessageWidth {
  FULL_WIDTH = 'full-width',
  FIT_CONTENT = 'fit-content',
}
